import { render, staticRenderFns } from "./FiloxeniaConfiguration.vue?vue&type=template&id=8fa3037a&scoped=true&"
import script from "./FiloxeniaConfiguration.vue?vue&type=script&lang=ts&"
export * from "./FiloxeniaConfiguration.vue?vue&type=script&lang=ts&"
import style1 from "./FiloxeniaConfiguration.vue?vue&type=style&index=1&id=8fa3037a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8fa3037a",
  null
  
)

export default component.exports